import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useGrossSalesV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.totalSalesReportV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getTotalSalesReportV2(), {
        params,
      });
      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicGrossSales: res.data.data.report.clinic_report,
        providerGrossSales: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    {
      staleTime: 0, // Always refetch
      cacheTime: 0, // Don't cache
      ...options,
    },
  );
};
